<div class="h-100 bg-light border-radius-3 p-5 color-dark overflow-auto">
  <div class="flex-column gap-3 h-100">
    <button
      pButton
      type="button"
      class="p-button p-button-primary p-button-outlined small icon-only back-button"
      (click)="logout()"
      [activityLogClick]="AnalyticClickEventNames.landing.BACK_TO_LOGIN">
      <shared-icon icon="alt-arrow-left" height="1rem" width="1rem" class="fill-dark" />
    </button>
    <div class="text-28 bold-800 text-center color-dark">Welcome to your new Mortgage Monitor</div>
    <div class="flex-column gap-5 h-100">
      <p class="text-18 text-center line-height-130">
        As part of our ongoing commitment to providing you with expert advice, we monitor your mortgage 24/7 to ensure that you’re always on
        the deal that’s best suited to your circumstances.
      </p>
      <div class="flex-column gap-3">
        <div class="flex gap-3">
          <div class="third-party-getting-started-item-icon-container">
            <shared-icon class="fill-dark" icon="mortgage" height="2rem" width="2rem" />
          </div>
          <span class="text-16 line-height-150">
            <span class="bold">Track the equity</span>
            that's building up in your property and send you monthly reports
          </span>
        </div>
        <div class="flex gap-3">
          <shared-icon class="fill-dark" icon="notification-unread" height="2rem" width="2rem" />
          <span class="text-16 line-height-150">
            <span class="bold">Notify you</span>
            the moment there is a better rate your rate changes or comes to an end
          </span>
        </div>
        <div class="flex gap-3">
          <shared-icon class="fill-dark" icon="file-with-magnifying-glass" height="2rem" width="2rem" />
          <span class="text-16 line-height-150">
            <span class="bold">Challenge your</span>
            current mortgage deal against thousands of other products
          </span>
        </div>
      </div>
      <form [formGroup]="acceptedTermsAndConditionsForm" (ngSubmit)="agreeAndLogin()">
        <div class="consent-container mt-auto">
          @if (company$ | async; as company) {
            <div>
              <div class="flex gap-2 align-items-center">
                <cp-checkbox [formControl]="acceptedTermsAndConditionsForm.controls.agreeTerms" />
                @if (company.companySettings.consentScreenText) {
                  <span
                    class="terms-and-conditions-label"
                    [innerHTML]="addClassAndTargetToInnerHtmlConsentText(company.companySettings.consentScreenText)"></span>
                } @else {
                  <span class="terms-and-conditions-label">
                    I agree to
                    <a class="underline" target="_blank" [href]="tacLink">Terms of Use</a>
                    and
                    <a class="underline" target="_blank" [href]="privacyPolicyLink">Privacy Policy</a>
                  </span>
                }
              </div>
              <div class="text-14 color-red mt-1">
                @if (showWarnState()) {
                  You have to agree with Terms of Use and Privacy Policy
                }
              </div>
            </div>
            <button
              pButton
              class="p-button p-button-primary w-100 centered"
              type="submit"
              [disabled]="acceptedTermsAndConditionsForm.invalid"
              [activityLogClick]="AnalyticClickEventNames.landing.ACCEPT_TERMS">
              Continue
            </button>
          }
        </div>
      </form>
    </div>
  </div>
</div>
